import React,{useState,useEffect} from 'react';
import { Link,useParams } from 'react-router-dom';
import MetaData from '../components/MetaData.js';
import { useSelector, useDispatch } from "react-redux";
import { clearErrors, getProduct, getProductByCate } from "../actions/productAction";
import { getAllCategories } from "../actions/categoryAction";
import Loader from "../components/Loader.js";
import { useAlert } from "react-alert";
import Pagination from "react-js-pagination";
import Slider from "@material-ui/core/Slider";

// const categories = [
//   "wall-tiles",
//   "floor-tiles",
//   "bathroom-tiles",
//   "outdoor-tiles",
//   "brick-&-metro tiles",
//   "mosaic-tiles",
// ];

const ShopByCate = () => {

    const alert = useAlert();
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [price, setPrice] = useState([0, 25000]);
    const [cate, setCate] = useState("");
    const [ratings, setRatings] = useState(0);
    const [active, setActive] = useState(null);

    const {
    products,
    loading,
    error,
    productsCount,
    resultPerPage,
    filteredProductsCount,
  } = useSelector((state) => state.products);

  const { categories } = useSelector((state) => state.categories);

    const { category } = useParams();

    const setCurrentPageNo = (e) => {
        setCurrentPage(e);
    };

    const priceHandler = (event, newPrice) => {
        setPrice(newPrice);
    };

    useEffect(() => {
        if (error) {
          alert.error(error);
          dispatch(clearErrors());
        }
        dispatch(getProductByCate(category))
        dispatch(getAllCategories());
    }, [dispatch, category, error, alert]);

    let count = filteredProductsCount;

	return (

        <>

        
        <MetaData title="Courses" />
			
			

    

    {/*<!-- Shop Section Start -->*/}
    <div className="section section-padding">
        <div className="container">
            {/*<!-- Product Section Wrapper Start -->*/}
            <div className="product-section-wrapper" style={{marginTop: '0px'}}>
                <div className="row flex-row-reverse">
                    <div className="col-lg-12">
                        {/*<!-- Shop top Bar Start -->*/}
                        <div className="shop-top-bar">
                            <div className="shop-text">
                                <p>
                                    {category} Courses
                                </p>
                            </div>
                            <div className="shop-tabs">
                                <ul className="nav">
                                    <li>
                                        <button className="active" data-bs-toggle="tab" data-bs-target="#grid">
                                            <i className="fa fa-th"></i>
                                        </button>
                                    </li>
                                    {/*<li>
                                        <button data-bs-toggle="tab" data-bs-target="#list">
                                            <i className="fa fa-list"></i>
                                        </button>
                                    </li>*/}
                                </ul>
                            </div>
                            {/*<div className="shop-sort">
                                <span className="title">Sort By :</span>
                                <select className="select2-2">
                                    <option value="featured">
                                        Featured
                                    </option>
                                    <option value="rating">Rating</option>
                                    <option value="price">Price</option>
                                </select>
                            </div>*/}
                        </div>
                        {/*<!-- Shop top Bar End -->*/}
                        
                        <div className="tab-content">
                            <div className="tab-pane fade show active" id="grid">
                                {/*<!-- Shop Product Wrapper Start -->*/}
                                {
            loading? ( <Loader />) :(
        <>
                                <div className="shop-product-wrapper courseSec">
                                    <div className="row">
                                    {
                                        products && products.map((product) =>{
                                            return(

                                                <div key={product._id} className="shpProd col-lg-3 col-md-4 col-sm-6 col-12">
                                                   <div className='single-product'>
                                                        <div className='product-content frontContent'>
                                                          <h4 className='title'>
                                                            <Link to={`/product/${product._id}`}>{product.name}</Link>
                                                          </h4>
                                                          <div className=''>
                                                            <p>
                                                              <span>{product.topic}</span> 
                                                            </p>
                                                          </div>
                                                        </div>
                                                        <div className="product-content backContent">
                                                          <div
                                                                    dangerouslySetInnerHTML={{
                                                                      __html: product?.description
                                                                        ?.split(" ")
                                                                        .slice(0, 20)
                                                                        .join(" ") + (product?.description?.split(" ").length > 10 ? "..." : ""),
                                                                    }}
                                                                  ></div>
                                                          <ul className='product-meta'>
                                                            <li>
                                                              <Link className='action' to={`/product/${product._id}`}>
                                                                <span>See Details</span>
                                                              </Link>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                </div>

                                                )
                                            
                                        })
                                    }
                                        
                                    </div>
                                </div>

                                </>
     )
        }
                                {/*<!-- Shop Product Wrapper End -->*/}

                            </div>
                            <div className="tab-pane fade" id="list">
                                {/*<!-- Shop Product Wrapper Start -->*/}
                                {
            loading? ( <Loader />) :(
        <>
                                <div className="shop-product-wrapper courseSec">
                                    {/*<!-- Single Product Start -->*/}
                                    {
                                        products && products.map((product) =>{
                                            return(    

                                                    <div key={product._id} className="shpProd single-product-02 product-list col-lg-4 col-md-4 col-sm-6 col-12">
                                                        <div className='single-product'>
                                                        <div className='product-content frontContent'>
                                                          <h4 className='title'>
                                                            <Link to={`/product/${product._id}`}>{product.name}</Link>
                                                          </h4>
                                                          <div className=''>
                                                            <p>
                                                              <span>{product.topic}</span> 
                                                            </p>
                                                          </div>
                                                        </div>
                                                        <div className="product-content backContent">
                                                          <div
                                                                    dangerouslySetInnerHTML={{
                                                                      __html: product?.description
                                                                        ?.split(" ")
                                                                        .slice(0, 20)
                                                                        .join(" ") + (product?.description?.split(" ").length > 10 ? "..." : ""),
                                                                    }}
                                                                  ></div>
                                                          <ul className='product-meta'>
                                                            <li>
                                                              <Link className='action' to={`/product/${product._id}`}>
                                                                <span>See Details</span>
                                                              </Link>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>

                                                )
                                            
                                        })
                                    }
                                    
                                    {/*<!-- Single Product End -->*/}

                                </div>
                                </>
     )
        }
                                {/*<!-- Shop Product Wrapper End -->*/}

                            </div>

                        </div>

                        {/*<!-- Page pagination Start -->*/}
                        
                            
                       
                    </div>
                    
                </div>
            </div>
            {/*<!-- Product Section Wrapper End -->*/}
        </div>
    </div>
    {/*<!-- Shop Section End -->*/}


        </>
    )
}

export default ShopByCate